const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const
const SESSION_KEY = 'thenormal_utm'

export type UtmParams = Partial<Record<typeof UTM_KEYS[number], string>>

export function captureUtmParams(): void {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  const utms: UtmParams = {}
  for (const key of UTM_KEYS) {
    const val = params.get(key)
    if (val) utms[key] = val
  }
  if (Object.keys(utms).length > 0) {
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(utms))
  }
}

export function getUtmParams(): UtmParams {
  if (typeof window === 'undefined') return {}
  try {
    const stored = sessionStorage.getItem(SESSION_KEY)
    return stored ? (JSON.parse(stored) as UtmParams) : {}
  } catch {
    return {}
  }
}

export function clearUtmParams(): void {
  if (typeof window === 'undefined') return
  sessionStorage.removeItem(SESSION_KEY)
}
